/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
/* import InActionsTravels from "./InActionsTravels";
import InActionsTravelsTrucks from "./InActionsTravelsTrucks";
import TripDetails from "./TripDetails/index"; */
import styled from "styled-components";
import queryString from "query-string";
import { getTripsCreatedByStateAPI } from "../../../../../api/modules";
import PaginationList from "../../../../../components/organisms/pagination-list/PaginationList";
import FinishedTravels from "./FinishedTravels";
import FinishedTravelsTrucks from "./FinishedTravelsTrucks";
import TripDetails from "../InActions/TripDetails";
import { errorToast } from "../../../../../services/toastService";

const RowStyled = styled(Row)`
  position: relative;
  width: 100%;
  bottom: 0px;
  margin-top: 20px;
`;

const ContainerList = styled.div`
  overflow-y: overlay;
`;

const Finished = ({ trips, state, ...rest }) => {
  const history = useHistory();
  const location = useLocation();
  const [tripId, setTripId] = useState(null);
  const [detailTrip, setDetailTrip] = useState(false);



  useEffect(() => {
    const { tripId, detailTrip } = queryString.parse(location.search);
    setTripId(tripId);
    setDetailTrip(detailTrip);
  }, [location]);

 

  const getScreen =
    tripId && detailTrip ? (
      <TripDetails detailTrip={detailTrip} tripId={tripId} tripState={5}/>
    ) : tripId ? (
      <FinishedTravelsTrucks tripId={tripId} />
    ) : (
      <FinishedTravels/>
    );

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <ContainerList>{getScreen}</ContainerList>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Finished;
